<template>
  <i-modal
    v-model="_modal"
    @on-visible-change="onVisibleChange"
    title="コンバート一括 送信設定"
    width="600"
    class="modal-convert-bulk"
  >
    <div class="container">
      <div class="convert_wrap">
        <template v-for="(listItem, listItemIdx) in list">
          <div :key="`${listItem.cd}_${listItemIdx}`" class="convert_item">
            <CheckboxBtn :label="listItem.name" :value.sync="listItem.checked" />
          </div>
        </template>
      </div>
      <div class="btn_wrap">
        <i-radio-group v-model="sendMode" type="button">
          <i-radio label="sending_reservation">送信予約</i-radio>
          <i-radio label="deleting_reservation">削除予約</i-radio>
        </i-radio-group>
      </div>
    </div>
    <div slot="footer">
      <i-button type="default" @click="onClickCancel">キャンセル</i-button>
      <i-button type="primary" @click="onClickSend">実行</i-button>
    </div>
  </i-modal>
</template>

<script>
import { Modal, Button, RadioGroup, Radio } from 'view-design'
import CheckboxBtn from '@/components/parts/CheckboxBtn'
import ConvertBulkRepository from '@/repositories/convertBulk'
export default {
  components: {
    'i-modal': Modal,
    'i-button': Button,
    'i-radio-group': RadioGroup,
    'i-radio': Radio,
    CheckboxBtn,
  },
  data() {
    return {
      load: false,
      percent: 0,
      list: [],
      sendMode: 'sending_reservation',
    }
  },
  props: {
    modal: {
      type: Boolean,
      default: false,
      required: true,
    },
  },
  computed: {
    _modal: {
      get() {
        return this.modal
      },
      set(val) {
        this.$emit('update:modal', val)
      },
    },
    property: {
      get() {
        return this.$store.getters['Property/getProperty']
      },
      set(val) {
        this.$store.commit('Property/setProperty', val)
      },
    },
    select: {
      get() {
        return this.$store.getters['SelectProperty/getProperty']
      },
      set(val) {
        this.$store.commit('SelectProperty/setProperty', val)
      },
    },
  },
  methods: {
    // モーダル 表示/非表示時の処理
    async onVisibleChange(isOpen) {
      // 対象サイトを取得する
      if (isOpen) {
        this.getConvertBulk()
      } else {
        setTimeout(this.resetParam, 300)
      }
    },
    async getConvertBulk() {
      await ConvertBulkRepository.get()
        .then(data => {
          if (data.result) {
            this.list = data.data
          } else {
            this.$router.push({ name: `error` })
          }
        })
        .catch(e => {
          console.log(e)
          this.$router.push({ name: `error` })
        })
        .finally(() => {})
    },
    // モーダル キャンセル時の処理
    onClickCancel() {
      this._modal = false
    },
    // コンバート一括指示を実行
    async onClickSend() {
      // 送信パラメータを設定
      let activePoralSite = _.filter(this.list, { checked: 1 })
      let potalSiteCds = _.map(activePoralSite, 'cd')
      if (potalSiteCds.length === 0) {
        alert('ステータスを変更するサイトを選択してください。')
        return
      }
      this.$store.dispatch('Loading/setLoading', true)

      try {
        await this.convBulkUpdate(potalSiteCds)

        alert('ステータスを更新しました。')
        this._modal = false
      } catch (e) {
        console.log(e)
        alert('ステータスの更新に失敗しました。')
      } finally {
        this.$store.dispatch('Loading/setLoading', false)
      }
    },
    async convBulkUpdate(potalSiteCds) {
      let ids = _.map(this.select, 'id')
      let mode = this.sendMode
      for (let id of ids) {
        const res = await ConvertBulkRepository.post(potalSiteCds, id, mode)
        if (res.result) {
          // ステータス変更結果を物件情報に反映する
          const data = res.data
          let property = _.find(this.property, {id: id})
          property.convert = data[id]
          property.load_convert = 2
        }
      }
    },
    // パラメータをリセットする
    resetParam() {
      // iviewモーダルが起動された際、bodyに付与されるstyle`overflow:hidden`が残るケースがあるので、
      // 動的にvisibleを付与する
      const bodyElement = document.getElementById('top')
      bodyElement.style.overflow = 'visible'

      this.load = false
      this.percent = 0
      this.list = []
      this.sendMode = 'sending_reservation'
    },
  },
}
</script>

<style lang="scss" scoped>
.modal-convert-bulk {
  .container {
    position: relative;
  }
  .convert_wrap {
    min-height: 60px;
    max-height: 200px;
    margin-bottom: 24px;
    overflow-y: scroll;
  }
  .convert_item {
    display: inline-block;
    margin: 4px;
  }
  .btn_wrap {
    text-align: center;
  }
}
</style>
